import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronsUpDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-chevrons-up-down-icon lucide-chevrons-up-down",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m7 15 5 5 5-5" }), /* @__PURE__ */ _jsx("path", { d: "m7 9 5-5 5 5" })]
});
export default SvgChevronsUpDown;
